import { z } from "zod";
import { OAuthProviderSchema } from "./oauth-providers";

export const WorkspaceOAuthRequestSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  provider: OAuthProviderSchema,
  userId: z.string(),
  createdAt: z.coerce.date(),
});

export type WorkspaceOAuthRequest = z.infer<typeof WorkspaceOAuthRequestSchema>;
